<comment>
  ## 图片上传组件 解决elementui上传之后的表单校验问题
  只适用于单图上传与回显
</comment>
<template>
    <div class="single-upload" >
        <el-upload
            v-if="isChange"
            v-loading="isUploaded"
            accept="image/jpeg,image/gif,image/png"
            :show-file-list="false"
            :action="baseUploadAction"
            list-type="picture-card"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :on-success="handleUpload"
            :before-upload="beforeUpload"
            :limit="limit"
            :on-error="handleError"
            :multiple="multiple"
        >
            <div v-if="value" class="divImg" >
                <img class="upload-img"  width="100%" :src=" value.indexOf('http://')>-1 ? value : baseFileContext+value" alt="" >
                <div class="delete-img"   >
                    <i class="el-icon-delete" @click.stop="deleteImg()"></i>
                </div>
            </div>
            <i v-else class="el-icon-plus"/>


        </el-upload>

        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src=" baseFileContext + dialogImageUrl" alt="">
        </el-dialog>

        <el-dialog :visible.sync="dialogVisible" />
    </div>
</template>

<script>
export default {
    props: {
        path: {
            type: String
        },
        value: {
            type: String
        },
        limit: {
            type: Number,
            default: 1
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

            dialogImageUrl: '',
            dialogVisible: false,

             baseUploadAction:'https://xiangjunkeji.cn/CM-API/upload/',
             baseFileContext:'https://xiangjunkeji.cn/CM-API/',

            //baseUploadAction:'http://127.0.0.1:5389/CM-API/upload/',
            //baseFileContext:'http://127.0.0.1:5389/CM-API/',


            isChange: true,
            isUploaded: false,
            dialogImageUrl: '',
            dialogVisible: false
        }
    },
    methods: {

        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        beforeUpload(file) {
            // 文件大小校验
            const judeSize = file.size / 1024 <  10240
            if (!judeSize) {
                this.$message({
                    message: `上传文件大小不能超过 ${( 10240 / 1024).toFixed()}M!`,
                    type: 'warning'
                })
                return false
            }
            this.isUploaded = true
        },
        // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
        handleChange(file, fileList) {
            this.handleImageList(fileList)
        },
        // 文件列表移除文件时的钩子
        handleRemove(file, fileList) {
            this.handleImageList(fileList)
        },
        // 文件上传成功时的钩子
        handleUpload(file, fileList) {
            try {
                if (fileList.response.state === 'success') {
                    this.handleImageList(fileList)
                    this.$message({message: '上传成功', type: 'success'})
                } else {
                    this.$message({message: '上传失败', type: 'error'})
                }
            } catch (e) {
                console.log(e)
            }

            this.isUploaded = false
            this.isChange = false
            setTimeout(() => {
                this.isChange = true
            }, 10)
        },
        // 上传错误时的钩子
        handleError() {
            this.isUploaded = false
            this.$message({ message: '上传失败', type: 'error' })
        },
        // 处理文件列表
        handleImageList(fileList) {
            try {
                const imageList = []
                fileList.length > 0 && fileList.forEach(item => {
                    if (item.response !== undefined) {
                        imageList.push(item.response.path)
                    }
                })
                //  发送上传之后的文件
                this.$emit('input', imageList.join(','))
                //  将触发类型改为change
                this.dispatch('ElFormItem', 'el.form.change', imageList)
            } catch (e) {
                throw e
            }
        },


        deleteImg(){
            this.$emit('input', '')
            //  将触发类型改为change
            this.dispatch('ElFormItem', 'el.form.change', [])
        },


        // 解决上传校验问题
        // elementUI mixins - emitter 中拷贝的
        dispatch(componentName, eventName, params) {
            var parent = this.$parent || this.$root
            var name = parent.$options.componentName

            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent
                if (parent) {
                    name = parent.$options.componentName
                }
            }
            if (parent) {
                parent.$emit.apply(parent, [eventName].concat(params))
            }
        }
    }
}
</script>
<style lang="less">

    .divImg{
        .delete-img {
            display: none;
        }


        &:hover{
            .delete-img {
                display: block;
                position: absolute;
                width: 100%;
                height:30px;
                line-height: 30px;
                left: 0px;
                bottom: 0px;
                background: #a9aeb5;
                z-index: 999;
                cursor: pointer;
                text-align: right;
                i {
                    margin: 5px 10px 0 0;
                    display: block;
                    font-size: 24px;
                    color: white;
                }
            }
        }

    }


    .el-upload-list__item-actions{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: default;
        text-align: center;
        color: #fff;
        opacity: 0;
        font-size: 20px;
        background-color: rgba(0,0,0,.5);
        transition: opacity .3s;
    }

    .el-icon-plus{
        font-size: 30px!important;
    }
    .el-icon-edit{
        font-size: 18px !important;
    }
    .el-icon-zoom-in{
        font-size: 18px !important;
    }
    .el-icon-delete{
        font-size: 18px !important;
        color:rgb(243, 143, 130);
    }


    .single-upload{
    .el-upload-list{
      img{
        object-fit: contain;
      }
    }
    .el-upload--picture-card{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img{
        width: 120px;
        height: 120px;
        object-fit: contain;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CmUpload/index.vue